import { useEffect, useState } from 'react'
import { Breadcrumb, Button, List, Card, ConfigProvider, Empty } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import { Droplet, Layout, Edit, Plus, Trash } from 'react-feather'
import { GraphView, SpreadSheetView } from 'Model'
import { QueryEditor } from 'Components'
import WeaverService from 'Services/WeaverService'
import { enc, getAppViews } from 'Services/WeaverUtils'
{ Meta } = Card
import {
  EmptyContainer,
  PageContainer,
  StyledList,
  StyledFooter
} from '../shared'
import './index.scss'

renderEmpty = ->
  <EmptyContainer>
    <div />
    <Empty />
    <div />
  </EmptyContainer>

ActionItem = ({ Icon, fn, rest... }) ->
  <Button
    type="text"
    icon={<Icon style={{ height: 20 }} />}
    size="small"
    disabled={!WeaverService.userCanEdit()}
    { rest... }
  />

Views = ({ match, history }) ->

  { path, params: { spaceId }} = match
  [isLoading, setIsLoading] = useState(true)
  [listData, setListData] = useState([])

  useEffect( ->
    ( ->
      loadViews()
    )()
    undefined
  , [])

  loadViews = ->
    setIsLoading(true)
    views = await getAppViews()
    setListData(_.orderBy(views.flat(), (v) -> v.get('name')))
    setIsLoading(false)

  destroy = (item) ->
    setIsLoading(true)
    await item.destroy()
    loadViews()

  <PageContainer>
    <Breadcrumb style={{ margin: 20, marginBottom: 0 }}>
      <Breadcrumb.Item>
        { Weaver.getInstance().currentProject()?.name() }
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to="/#{ spaceId }/settings/views">
          Views
        </Link>
      </Breadcrumb.Item>
    </Breadcrumb>
    <ConfigProvider renderEmpty={renderEmpty}>
      <StyledList
        itemLayout="horizontal"
        size="large"
        dataSource={listData}
        loading={isLoading}
        className="views-list-container"
        renderItem={(item) -> (
          if item instanceof GraphView
            avatar = <Droplet />
          else if item instanceof SpreadSheetView
            avatar = <Layout />

          <List.Item
            key={item.id()}
            actions={[
              <ActionItem
                Icon={Edit}
                onClick={ -> history.push("/#{ spaceId }/settings/views/#{ enc(item.id()) }")}
                type="link"
              />,
              <ActionItem
                Icon={Trash}
                onClick={ -> destroy(item)}
                danger
              />
            ]}
          >
            <List.Item.Meta
              avatar={avatar}
              title={item.get('name')}
              description={_.startCase(_.lowerCase(item.get('type')))}
            />
            <QueryEditor
              height="100px"
              width="50%"
              value={item.get('query')}
              style={{ transform: 'scale(0.75)', borderRadius: 9, margin: '-10px 0' }}
              mode={item.get('queryLang')}
              readOnly={true}
            />
          </List.Item>
        )}
      />
    </ConfigProvider>
    <StyledFooter>
      <Button
        icon={<Plus style={{ height: 16, margin: '-3px 3px' }} />}
        type="primary"
        data-testid="create-new-view-button"
        onClick={ -> history.push("/#{ spaceId }/settings/views/new")}
        shape="round"
        size="large"
        disabled={!WeaverService.userCanEdit()}
      >
        Add a new view
      </Button>
    </StyledFooter>
  </PageContainer>

export default withRouter(Views)
